import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { Category } from "@insite/client-framework/Services/CategoryService";
import {
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";
import CustomloadProductInfoList from "@tSurya/Store/Components/ProductInfoList/Handlers/LoadProductInfoListExtention";

interface Parameter {
    carouselId: string;
    numberOfProductsToDisplay: number;
    isProductDetailsPage: boolean;
    productId?: string;
    isProductListPage: boolean;
    category?: Category;
    isBrandDetailsPage: boolean;
    brand?: BrandModel;
    productidlist: string;
}

export interface CustomGetProductCollectionApiV2Parameter extends GetProductCollectionApiV2Parameter {
    productNumbers?: string[];
}

interface Props {
    getProductCollectionParameter?:
        | CustomGetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter;
    extraProductCollectionParameter?: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter;
}

type HandlerType = Handler<Parameter, Props>;

export const LoadProductsById: HandlerType = props => {
    const {
        parameter: { numberOfProductsToDisplay, productidlist },
    } = props;
    if (productidlist === "") {
        return;
    }

    props.getProductCollectionParameter = {
        productNumbers: productidlist.split(","),
        pageSize: numberOfProductsToDisplay,
    };
};

export const LoadProducts: HandlerType = props => {
    if (!props.getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = props.extraProductCollectionParameter
        ? {
              getProductCollectionParameter: props.extraProductCollectionParameter,
              numberOfProductsToDisplay: props.parameter.numberOfProductsToDisplay,
          }
        : undefined;

    if (props.getProductCollectionParameter) {
        props.getProductCollectionParameter.expand = props.getProductCollectionParameter?.expand || [];
        // props.getProductCollectionParameter.expand.push("images")
        // props.getProductCollectionParameter?.expand?.push("properties");
    }

    props.dispatch(
        CustomloadProductInfoList({
            id: props.parameter.carouselId,
            getProductCollectionParameter: props.getProductCollectionParameter,
            extraProductOptions,
        }),
    );
};

export const chain = [
    LoadProductsById,
    LoadProducts,
];

const surLoadCarouselProductWithIds = createHandlerChainRunner(chain, "CenLoadCarouselProductsWithIds");
export default surLoadCarouselProductWithIds;
